{
  "meta": {
    "actual": "Import actual expenses",
    "planned": "Import planned expenses"
  },
  "import": "Import {packageType} expenses",
  "advantages": "Benefits",
  "types": {
    "actual": "actual",
    "planned": "planned",
    "crm": "crm",
    "specific": "specific"
  },
  "import_types": {
    "MANUAL": "import manual",
    "CRM": "import CRM",
    "SPECIFIC": "import specific expenses"
  },
  "history": {
    "actual": "actual expenses",
    "planned": "planned expenses",
    "specific": "specific actual expenses"
  },
  "toast": {
    "pending": "{expenseType} import is pending",
    "done": "{expenseType} import completed successfully",
    "failed": "{expenseType} import completed with failure",
    "actual": "actual expenses",
    "planned": "planned expenses",
    "crm": "CRM expenses",
    "specific": "specific expenses",
    "generation_failed": "Sorry, something went wrong. Please try again later."
  },
  "tabulations": {
    "generate": {
      "cta_label": "Generate template",
      "no_generated_template": "No generated file",
      "generated_at": "Generated on {date}",
      "generation_loading": "Template generation in progress",
      "tab_title": "Generate/Upload an import",
      "template": {
        "title": "Generate a template",
        "information": "Please generate/download the template before uploading a {packageType} expenses import"
      },
      "select_import_type": {
        "title": "Select import type",
        "information": "Please select the import type",
        "advantages_types": {
          "ALL": "All"
        }
      },
      "upload": {
        "modal": {
          "title": "Upload a specific import",
          "text": "The import will delete all existing actual expenses and will only modify the expenses fields of the import."
        },
        "title": "Upload an import",
        "information": "Please wait for the upload to complete after uploading a {packageType} expenses import",
        "input_title": "Please upload a {packageType} expenses import",
        "format": {
          "authorized": "Authorized formats: XLSX",
          "accepted": "Accepted file: Ticket template"
        },
        "cta_label": "Select a file",
        "cta_import": "Upload your import"
      }
    },
    "history": {
      "list_title": "Imported template",
      "tab_title": "Import History",
      "column": {
        "state": "State",
        "type": "Type",
        "created_at": "Imported On",
        "action": "Action"
      },
      "status": {
        "PENDING": "PENDING",
        "FAILED": "FAILED",
        "DONE": "SUCCESS"
      },
      "type": {
        "MANUAL": "Manual",
        "CRM": "CRM",
        "SPECIFIC": "expenses specific"
      }
    }
  }
}
